



























































































































































































import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import { GetterNames } from '@/constants/GetterNames';
import { ActionNames } from '@/constants/ActionNames';

@Component({
    components: {
        Loading,
    },
})
export default class NawComponent extends Vue {
    public loadingEmail: boolean = false;

    public loadingPassword: boolean = false;

    public loadingInvoiceEmail: boolean = false;

    public loadingAddressUpdate: boolean = false;

    public loadingBusinessData: boolean = false;

    public addressData: {
        street: string,
        houseNumber: string,
        zipCode: string,
        city: string,
    } = {
        street: '',
        houseNumber: '',
        zipCode: '',
        city: ''
    };

    public emailData: {
        email: string,
        emailRepeat: string,
    } = {
        email: '',
        emailRepeat: ''
    };

    public passwordData: {
        oldPassword: string,
        password: string,
        passwordRepeat: string,
    } = {
        oldPassword: '',
        password: '',
        passwordRepeat: ''
    };

    public invoiceEmailData: {
        email: string,
        emailRepeat: string,
    } = {
        email: '',
        emailRepeat: ''
    };

    public businessData: {
        vatNumber: string,
        businessName: string,
    } = {
        vatNumber: '',
        businessName: ''
    };

    public errorEmail: {
        type: string,
        message: string,
        show: boolean,
    } = {
        show: false,
        type: '',
        message: ''
    };

    public errorAddress: {
        type: string,
        message: string,
        show: boolean,
    } = {
        show: false,
        type: '',
        message: ''
    };

    public errorPassword: {
        type: string,
        message: string,
        show: boolean,
    } = {
        show: false,
        type: '',
        message: ''
    };

    public errorBusiness: {
        type: string,
        message: string,
        show: boolean,
    } = {
        show: false,
        type: '',
        message: ''
    };

    public errorInvoiceEmail: {
        type: string,
        message: string,
        show: boolean,
    } = {
        show: false,
        type: '',
        message: ''
    };

    get fullName(): string {
        return this.$store.getters[ GetterNames.FULL_NAME ];
    }

    get email(): string {
        return this.$store.getters[ GetterNames.EMAIL ];
    }

    get cardNumber(): number {
        return this.$store.getters[ GetterNames.CARD_NUMBER ];
    }

    get isCompany(): boolean {
        return this.$store.getters[ GetterNames.IS_COMPANY ];
    }

    get businessName(): string {
        const businessName = this.$store.getters[ GetterNames.BUSINESS_NAME ];

        this.businessData = {
            ...this.businessData,
            businessName
        };

        return businessName;
    }

    get vatNumber(): string {
        const vatNumber = this.$store.getters[ GetterNames.VAT_NUMBER ];

        this.businessData = {
            ...this.businessData,
            vatNumber
        };

        return vatNumber;
    }

    get address(): string {
        const address = this.$store.getters[ GetterNames.ADDRESS ];

        this.addressData = {
            street: address.street,
            houseNumber: address.houseNumber,
            zipCode: address.zipCode,
            city: address.city
        };

        return this.$store.getters[ GetterNames.ADDRESS ];
    }

    public created() {
        if (this.isCompany) {
            this.businessData.businessName = this.businessName;
            this.businessData.vatNumber = this.vatNumber;
        }
    }

    public async updateBusinessData() {
        this.loadingBusinessData = true;

        const success = await this.$store.dispatch(ActionNames.UPDATE_BUSINESS_DATA, this.businessData);

        if ( !success ) {
            this.errorBusiness = {
                show: true,
                type: 'warning',
                message: 'Er ging iets fout tijdens het aanpassen van je bedrijfsgegevens'
            };
        } else {
            this.errorBusiness = {
                show: true,
                type: 'success',
                message: 'Je bedrijfsgegevens zijn aangepast'
            };
        }

        this.loadingBusinessData = false;
    }

    public async updatePassword() {
        this.loadingPassword = true;

        if (
            this.passwordData.oldPassword === '' ||
            this.passwordData.passwordRepeat === '' ||
            this.passwordData.password === ''
        ) {
            this.errorPassword = {
                show: true,
                type: 'warning',
                message: 'Vul alle velden in'
            };

            this.loadingPassword = false;

            return;
        }

        if ( this.passwordData.passwordRepeat === this.passwordData.password ) {
            const success = await this.$store.dispatch(ActionNames.UPDATE_PASSWORD, {
                oldPassword: this.passwordData.oldPassword,
                newPassword: this.passwordData.password,
                newPasswordRepeat: this.passwordData.passwordRepeat
            });

            if ( !success ) {
                this.errorPassword = {
                    show: true,
                    type: 'warning',
                    message: 'Er ging iets fout tijdens het aanpassen van je wachtwoord'
                };
            } else {
                this.errorPassword = {
                    show: true,
                    type: 'success',
                    message: 'Je wachtwoord is aangepast'
                };
            }
        } else {
            this.errorPassword = {
                show: true,
                type: 'warning',
                message: 'De wachtwoorden komen niet overeen'
            };
        }

        this.loadingPassword = false;
    }

    public async updateAddress() {
        this.loadingAddressUpdate = true;

        const success = await this.$store.dispatch(ActionNames.UPDATE_ADDRESS, this.addressData);

        if ( !success ) {
            this.errorAddress = {
                show: true,
                type: 'warning',
                message: 'Er ging iets fout tijdens het aanpassen van je adresgegevens'
            };
        } else {
            this.errorAddress = {
                show: true,
                type: 'success',
                message: 'Je adresgegevens zijn aangepast'
            };
        }

        this.loadingAddressUpdate = false;
    }

    public async updateEmail() {
        this.loadingEmail = true;

        if ( this.emailData.email === '' || this.emailData.emailRepeat === '' ) {
            this.errorEmail = {
                show: true,
                type: 'warning',
                message: 'Vul alle velden in'
            };

            this.loadingEmail = false;

            return;
        }

        if ( this.emailData.email === this.emailData.emailRepeat ) {
            const success = await this.$store.dispatch(ActionNames.UPDATE_USER_DATA, {
                firstName: false,
                middleName: false,
                surName: false,
                email: this.emailData.email,
                license: false
            });

            if ( !success ) {
                this.errorEmail = {
                    show: true,
                    type: 'warning',
                    message: 'Er ging iets fout tijdens het aanpassen van je email'
                };
            } else {
                this.errorEmail = {
                    show: true,
                    type: 'success',
                    message: 'Je email is aangepast'
                };
            }
        } else {
            this.errorEmail = {
                show: true,
                type: 'warning',
                message: 'De emails komen niet overeen'
            };
        }

        this.loadingEmail = false;
    }
}
